import { Card, Typography } from "@packages/ds";
import styled from "styled-components";

import Button from "ds/Button";
import Tag from "ds/Tag";
import { breakpoints } from "Libs/theme";

export const LoaderWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const BorderedCard = styled(Card)`
  flex: 1;
  flex-grow: 0;
  border-radius: var(
    --box-wrapper-section-border-radius,
    var(--section-8px-border-radius, var(--8px))
  );
  background-color: var(--mode-bg-neutral-weaker);
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-top: 26px;
  margin-bottom: 46px;
`;

export const Totals = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  @media (min-width: ${breakpoints[0]}) {
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const UserLabel = styled(Typography.Title)`
  font-size: 15px;
  font-weight: 600;
  letter-spacing: unset;
  width: max-content;
  @media (min-width: ${breakpoints[2]}) {
    min-width: 100px;
  }
`;

export const Row = styled.div<{ $gap?: string }>`
  display: flex;
  flex-direction: row;
  gap: ${props => props.$gap || "32px"};
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ColumnCenter = styled(Column)`
  gap: 24px;
  @media (min-width: ${breakpoints[0]}) {
    align-items: center;
  }
`;

export const Total = styled.div`
  display: flex;
  align-items: end;
`;

export const TotalQuantityDiscount = styled(Typography.Title)`
  line-height: 1;
  margin-right: 4px;
`;
export const TotalQuantity = styled(Typography.Title)`
  color: var(--text-neutral-weakest-disabled, #b1b7ba);
  text-decoration: line-through;
  font-size: 15px;
  font-weight: 600;
  line-height: 16px;
`;
export const PricingButton = styled(Button)`
  font-size: 13px;
  font-weight: 600;
`;

export const Notices = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 42px;
  font-size: 13px;
`;

export const FirstProjectIncentiveTag = styled(Tag)`
  margin-right: 8px;
`;

export const TermsInfo = styled(Typography.BodyText)`
  color: var(--text-neutral-weakest, #8b9397);
`;

export const BadgeSection = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  gap: 8px;
  margin: 8px 24px 24px;
`;

export const Badge = styled.div`
  box-sizing: border-box;
  padding: 2px 8px;
  border-radius: 4px;
  display: flex;
  gap: 4px;
  white-space: nowrap;
  font-size: 12px;
  line-height: 20px;
  font-weight: 600;
  background-color: var(--mode-bg-neutral-weaker);
  color: var(--mode-text-neutral-default-weak);
`;
